import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Clock = (props: Icon): React.ReactElement => {
  if (props.variant === "line") {
    return (
      <svg
        viewBox="0 0 24 24"
        style={{ ...style(props.size, props.height), ...props.style }}
        className={props.className}
      >
        <path
          fill={props.color || theme.palette.grey600}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4ZM12 5.33333C8.3181 5.33333 5.33333 8.3181 5.33333 12C5.33333 15.6819 8.3181 18.6667 12 18.6667C15.6819 18.6667 18.6667 15.6819 18.6667 12C18.6667 8.3181 15.6819 5.33333 12 5.33333ZM12.6622 8.58892C12.6237 8.25736 12.3419 8 12 8L11.9223 8.00449C11.5907 8.043 11.3333 8.32478 11.3333 8.66667V12H9.33333L9.25559 12.0045C8.92403 12.043 8.66667 12.3248 8.66667 12.6667C8.66667 13.0349 8.96514 13.3333 9.33333 13.3333H12L12.0777 13.3288C12.4093 13.2903 12.6667 13.0086 12.6667 12.6667V8.66667L12.6622 8.58892Z"
        />
      </svg>
    );
  }

  return (
    <svg
      viewBox="0 0 24 24"
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
    >
      <path
        fill={props.color || theme.palette.grey600}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4C7.582 4 4 7.582 4 12C4 16.418 7.582 20 12 20C16.418 20 20 16.418 20 12C20 7.582 16.418 4 12 4ZM12 8C11.632 8 11.3333 8.29867 11.3333 8.66667V12H9.33333C8.96533 12 8.66667 12.2987 8.66667 12.6667C8.66667 13.0347 8.96533 13.3333 9.33333 13.3333H12.6667V8.66667C12.6667 8.29867 12.368 8 12 8ZM6 12C6 15.3133 8.68667 18 12 18C15.314 18 18 15.3133 18 12C18 8.686 15.314 6 12 6C8.68667 6 6 8.686 6 12Z"
      />
    </svg>
  );
};
